import { Check, WclImg } from "../../assets/images";
import { useNavigate } from "react-router-dom";
import RouteNames from "../../routes/type";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { cleanUpClaim } from "../../store/mattress-claim/actions";
import FAQs from "./FAQs";

const faqs = [
  {
    question: "Does receiving a replacement product extend my warranty period?",
    answer:
      "No. The warranty period remains based on the original purchase date.",
  },
  {
    question:
      "How long does it typically take to receive a replacement product?",
    answer:
      "You can expect to receive the new product within 14 business days from the date of order.",
  },
  {
    question:
      "When is it safe to dispose of the old product after requesting a replacement?",
    answer:
      "Do not dispose of the old product until the new product has arrived.",
  },
];

function Home() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleFileClaim = () => {
    dispatch(cleanUpClaim());
    navigate(RouteNames.CREATE_CLAIM);
  };
  const { t } = useTranslation();

  const steps = [
    "Enter customer information",
    "Enter purchase information",
    "Enter damage details",
    "Upload necessary documents",
    "Submit",
  ];

  return (
    <div className="">
      <div className="bg-blue-light text-center p-4  flex items-end justify-center hero-banner">
        <img src={WclImg} alt="Welcome" className="mx-auto" />
      </div>
      <div className="sm:mt-12 mt-8">
        <h3 className="font-semibold sm:text-3xl text-[22px] sm:px-10 px-4 text-center ">
          {t("Welcome to the Mattress Claim Request System")}
        </h3>
        <ul className="min-[400px]:text-lg flex flex-col gap-y-3 mx-auto px-6 w-fit mt-8">
          {steps.map((label) => (
            <li key={label} className="flex items-center gap-3">
              <img src={Check} alt="check" />
              <span>{t(label)}</span>
            </li>
          ))}
        </ul>
      </div>
      <div className="text-center sm:mt-10 mt-8 mb-6">
        <button
          type="button"
          aria-label="button"
          onClick={handleFileClaim}
          className="p-2 rounded-full text-center bg-brand-color h-[50px] w-[247px] text-white hover:brand-hover"
        >
          {t("Start")}!
        </button>
      </div>
      <div className="mb-10">
        <h3 className="font-semibold text-xl px-4 text-center">
          {t("Frequently Asked Questions")}
        </h3>
        <div className="px-4 mt-3">
          {faqs.map((item, index) => (
            <FAQs item={item} key={index} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Home;
